import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/shiharai_01.png")